import ValidService from "../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  "id": undefined,
  "ten": undefined,
  "mo_ta": undefined,
  "mau": undefined,
  "chiet_khau": [
    {
      "san_pham_id": undefined,
      "gia_tri": undefined,
    }],
  "chiet_khau_khach": undefined,
  "tang_cap":
  {
    "cap_id": undefined,
    "dieu_kien":
    {
      "doanh_thu_365": undefined,
      "so_don_365": undefined,
    }
  },
  "giam_cap":
  {
    "cap_id": undefined,
    "dieu_kien":
    {
      "doanh_thu_365": undefined,
      "so_don_365": undefined,
    }
  },
  "hieu_luc": undefined,
  "cong_khai": false,
  "thoi_diem_tao": undefined,
  "nguoi_tao_id": undefined,
  "thoi_diem_cap_nhat": undefined,
  "nguoi_cap_nhat_id": undefined,
}

// validation form
model.validForm = {};
model.dieuKien = [];
model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  filters: "",
  recordSelected: [],
};

export default model;
